import { EvaluationCreator } from '../interfaces/Organization';

export class MEvaluationCreator{

    public id: number;
    public name: string;
    public active: boolean;
    public email: string;
    public avatar: string;
    public username: string;

    constructor(user: EvaluationCreator){
        this.id = user.usuario.id;
        this.active = user.activo === 1;
        this.name = user.usuario.name;
        this.email = user.usuario.email;
        this.avatar = user.usuario.avatar;
        this.username = user.usuario.username;
    }

}
